import React from 'react';
import Link from 'next/link';
import { Article } from '@/types/Blog';

interface ReadAlsoSectionProps {
  articles: Article[];
}

const ReadAlsoSection: React.FC<ReadAlsoSectionProps> = ({ articles }) => {
  return (
    <div className='rounded-md  text-white relative ml-8 lg:ml-0'>
      <div className='rounded-md absolute w-full h-full bg-gradient-to-br from-defaultBlue via-[#63C8ED] to-cyan-300 top-0 -left-8' />
      <div className='relative pb-5'>
        <h2 className="text-xl font-bold p-5 py-3 pl-0 lg:pl-8  ">Baca Juga</h2>
        <div className="flex flex-col gap-2 pl-0 lg:pl-8">
          {articles.slice(0, 4).map((article, index) => (
            <Link href={`/iit-news/${article.slug}`} key={index}>
              <div key={article.slug} className="flex items-center rounded-md pr-5  overflow-hidden h-32 bg-white shadow hover:scale-[1.025] duration-100">
                <img
                  src={article.image}
                  alt={article.title}
                  className=" w-32 h-full object-cover"
                />
                <div className="ml-4">
                  <h3 className="font-semibold text-defaultBlue text-sm line-clamp-1">{article.category}</h3>
                  <p className="font-semibold mt-1 line-clamp-2 text-black">
                    {article.title}
                  </p>
                  <p className="text-sm text-gray-500 mt-1 line-clamp-1">{article.time} | {article.date}</p>
                </div>
              </div>
            </Link>

          ))}
        </div>
      </div>

    </div>
  );
};

export default ReadAlsoSection;